import { createContext, useContext, useState, type ReactNode } from "react";

export type QuickCreateTarget = "new-client" | "new-project" | "new-template" | "log-time";

interface QuickCreateContextType {
  trigger: QuickCreateTarget | null;
  setTrigger: (t: QuickCreateTarget | null) => void;
}

const QuickCreateContext = createContext<QuickCreateContextType | null>(null);

export function QuickCreateProvider({ children }: { children: ReactNode }) {
  const [trigger, setTrigger] = useState<QuickCreateTarget | null>(null);
  return (
    <QuickCreateContext.Provider value={{ trigger, setTrigger }}>
      {children}
    </QuickCreateContext.Provider>
  );
}

export function useQuickCreate() {
  const ctx = useContext(QuickCreateContext);
  if (!ctx) throw new Error("useQuickCreate must be used inside QuickCreateProvider");
  return ctx;
}
